module.exports = __webpack_public_path__ + "img/img6.bd41ee8b.svg";